import omitDeep from "omit-deep-lodash";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import {
  PRODUCT_RANGE,
  PRODUCT_RANGES,
} from "utils/api/graphql/queries/product-range-advisor-codes";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path);
  const { data, loading, error } = useQuery(PRODUCT_RANGE, {
    variables: { where: { id } },
  });
  const [updateProductRange] = useMutation(
    graphql.mutations.UPDATE_PRODUCT_RANGE,
    {
      refetchQueries: [
        {
          query: PRODUCT_RANGES,
          awaitRefetchQueries: true,
          variables: {
            ...INITIAL_VALUES,
            orderBy: [{ code: "ASC" }],
          },
        },
      ],
      onCompleted: () => {
        navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path);
      },
    },
  );
  const onSubmit = (values) => {
    const labelTrimmed = (values.label || "").trim();
    return updateProductRange({
      variables: {
        where: { id },
        data: {
          code: values.code.trim(),
          label: labelTrimmed || null,
        },
      },
    });
  };

  if (loading || error) return <Loading />;

  return (
    <View
      onSubmit={onSubmit}
      cancel={cancel}
      data={omitDeep(data.productRange, "__typename")}
    />
  );
};

export default Detail;
